declare namespace Profile {
  export type Fields = {
    name: string;
    photo: string | null;
    username: string;
  };

  export type Response = Fields;

  export type Update = Partial<Response>;

  export type Get = {
    uid: string;
    name: string;
    photo: string | null;
    username: string;
  };

  export interface Snapshot extends Get {
    snap: firebase.firestore.DocumentSnapshot;
  }
}

export default Profile;
